import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, {
  memo,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import GoogleMapComponent from "../map/GoogleMapComponent";
import { LocationOn } from "@mui/icons-material";
import { IoMdLocate } from "react-icons/io";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import { stationFilterData } from "../../data/svg/station_filter_data";
import eko from "../../assets/img/eko.png";
import sonerco from "../../assets/img/sonerco-logo.png";
import axco from "../../assets/img/axco-logo.png";
import petroCanada from "../../assets/img/petro-canada.png";
import shell_logo from "../../assets/img/shell-logo.jpg";
import a_w_logo from "../../assets/img/a_w_logo.png";
import sprint from "../../assets/img/sprint.png";

import gulf from "../../assets/img/gulf.png";
import irving from "../../assets/img/irving.png";
import vp_racing from "../../assets/img/vp_racing.png";
import xtr from "../../assets/img/xtr.png";
import recharge_logo from "../../assets/img/recharge_sprint.png";

import { useDispatch, useSelector } from "react-redux";
import { getStationList } from "../../server/server";
import { setStationList } from "../../redux/features/stations/stationsSlice";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { useTheme } from "@emotion/react";
import NoDataFound from "./NoDataFound";
import Station from "./Station";
import SideBarMenu from "./SideBarMenu";
import AdvancedFilter from "./AdvancedFilter";
import { calculateDistanceRaw } from "../../helper/distanceCalc";
const isDev = process.env.REACT_APP_TYPE === "development";

const FilterAndMap = memo(() => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isSmMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const inputRef = useRef(null);

  const [locationSearch, setLocationSearch] = useState("");
  const [filterTrigger, setFilterTrigger] = useState(0);
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script-search",
    googleMapsApiKey: isDev
      ? process.env.REACT_APP_GOOGLE_API_KEY
      : window?.depanneursprintSettings?.googleMapApiKey,
    libraries: ["places", "geometry", "drawing"],
    region: "CA",
    language: "fr",
  });
  const dispatch = useDispatch();
  const stations = useSelector((state) => state.stations.stattionList);
  const allStatationList = useSelector(
    (state) => state.stations.allStatationList,
  );
  const [geolocation, setGeolocation] = useState({
    latitude: 0,
    longitude: 0,
    state: null,
  });
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [navigate, setNavigate] = useState(null);
  const [advancedFilterOpen, setAdvancedFilterOpen] = useState(false);
  const [activeFilterOption, setActiveFilterOption] = useState([]);
  const handleActiveFilterOption = (active) => {
    if (activeFilterOption.includes(active)) {
      setActiveFilterOption(
        activeFilterOption.filter((item) => item !== active),
      );
    } else {
      setActiveFilterOption([...activeFilterOption, active]);
    }
  };

  const getGeoLocation = async () => {
    const permissionStatus = await navigator.permissions.query({
      name: "geolocation",
    });
    if (permissionStatus.state === "denied") {
      console.log("Geolocation permission denied");
      return;
    }
    if (permissionStatus.state === "prompt") {
      console.log("Geolocation permission prompt");
      setGeolocation((prev) => ({ ...prev, state: "prompt" }));
    } else if (permissionStatus.state === "granted") {
      console.log("Geolocation permission granted");
      setGeolocation((prev) => ({ ...prev, state: "granted" }));
    }
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        setGeolocation((prev) => {
          return {
            ...prev,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
        });
      });
    } else {
      console.log("Geolocation is not available");
    }
  };
  useLayoutEffect(() => {
    getGeoLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilterTrigger((prev) => prev + 1); // Force re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedLocation,
    activeFilterOption,
    selectedLocation?.length,
    activeFilterOption?.length,
  ]);

  const filterStationHandler = () => {
    let filteredData = [...allStatationList];

    const selectedBannieres = [];
    let sprintSelected = false;
    let shellSelected = false;
    let rechargeSelected = false;

    // Map selected keys to actual banniere values
    selectedLocation.forEach((selected) => {
      switch (selected) {
        case "sprintStationList":
          sprintSelected = true;
          break;

        case "petroCanadaStationList":
          selectedBannieres.push("Petro-Canada");
          break;

        case "ekoStationList":
          selectedBannieres.push("Eko");
          break;

        case "sonercoStationList":
          selectedBannieres.push("Sonerco");
          break;

        case "axcoStationList":
          selectedBannieres.push("Axco");
          break;

        case "shellStationList":
          shellSelected = true;
          break;

        case "ultramarStationList":
          selectedBannieres.push("Ultramar");
          break;

        case "Restaurant":
          selectedBannieres.push("A&W");
          break;
        case "XtrStationList":
          selectedBannieres.push("XTR");
          break;
        case "GulfStationList":
          selectedBannieres.push("Gulf");
          break;
        case "IrvingStationList":
          selectedBannieres.push("Irving");
          break;
        case "VpRacingStationList":
          selectedBannieres.push("VP FUELS");
          break;
        case "rechargeStationList":
          rechargeSelected = true;
          break;
        default:
          break;
      }
    });

    // -------------------------------------------
    // APPLY MAIN FILTER LOGIC
    // -------------------------------------------
    filteredData = filteredData.filter((item) => {
      const banniere = item.customFields.banniere;
      const fournisseur = item.customFields.fournisseur_dep;

      // CASE 1: Sprint + Banniere → AND logic
      if (sprintSelected && selectedBannieres.length > 0) {
        return fournisseur === "Sprint" && selectedBannieres.includes(banniere);
      }

      // CASE 2: Only Sprint selected
      if (sprintSelected) {
        return fournisseur === "Sprint";
      }

      // CASE 3: Only Shell selected
      if (shellSelected) {
        return banniere === "Shell" && fournisseur === "Sprint";
      }

      // CASE 4: Only Gulf selected
      if (selectedLocation.includes("GulfStationList")) {
        return banniere === "Gulf";
      }

      // CASE 5: Irving Selected → AND logic
      if (selectedLocation.includes("IrvingStationList")) {
        return banniere === "Irving";
      }

      // CASE 6: VP Racing Selected → AND logic
      if (selectedLocation.includes("VpRacingStationList")) {
        return banniere === "VP FUELS";
      }

      // CASE 7: XTR Selected → AND logic
      if (selectedLocation.includes("XtrStationList")) {
        return banniere === "XTR";
      }

      // CASE 8: Recharge Sprint Selected
      if (rechargeSelected) {
        return (
          item.customFields?.borne_de_recharge_ve &&
          item?.customFields?.source === "eddie"
        );
      }

      // CASE Last: Only Bannieres selected → OR logic
      if (selectedBannieres.length > 0) {
        return selectedBannieres.includes(banniere);
      }
      


      // CASE 5: No filter
      return true; // Default to show only Shell stations when no filter is selected
    });

    // -------------------------------------------
    // Apply activeFilterOption as AND logic
    // -------------------------------------------
    if (activeFilterOption.length > 0) {
      filteredData = filteredData.filter((item) =>
        activeFilterOption.every((key) => item.customFields[key]),
      );
    }

    // -------------------------------------------
    // Sort by distance
    // -------------------------------------------
    filteredData = filteredData.sort((a, b) => {
      const distanceA = calculateDistanceRaw(
        a.latitude,
        a.longitude,
        geolocation.latitude,
        geolocation.longitude,
      );

      const distanceB = calculateDistanceRaw(
        b.latitude,
        b.longitude,
        geolocation.latitude,
        geolocation.longitude,
      );

      return distanceA - distanceB;
    });

    dispatch(setStationList(filteredData));
  };

  const resetFilterHadnler = async () => {
    const filterStattionData = await getStationList();
    if (filterStattionData) {
      dispatch(setStationList(filterStattionData));
    }
  };

  useEffect(() => {
    if (filterTrigger > 0) {
      filterStationHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterTrigger]);

  useEffect(() => {
    // localtionbase filter accending order
    if (geolocation?.latitude && geolocation?.longitude) {
      const sortedStations = [...stations].sort((a, b) => {
        const distanceA = calculateDistanceRaw(
          a.latitude,
          a.longitude,
          geolocation.latitude,
          geolocation.longitude,
        );
        const distanceB = calculateDistanceRaw(
          b.latitude,
          b.longitude,
          geolocation.latitude,
          geolocation.longitude,
        );

        return distanceA - distanceB;
      });
      dispatch(setStationList(sortedStations));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geolocation]);

  return (
    <Box>
      <Box
        sx={{
          boxShadow: "0 14px 8px -8px rgba(0,0,0,0.09)",
          padding: "35px 20px",
          boxSizing: "border-box",
          backgroundColor: "var(--white)",
          zIndex: 1,
          position: "relative", // Make
        }}
      >
        <Grid
          container
          sx={{ paddingLeft: 3 }}
          alignItems={"center"}
          columnSpacing={2}
        >
          <Grid item sm={12} md={10} lg={11} container columnSpacing={3}>
            <Grid xs={12} container lg={4} rowSpacing={2}>
              <Grid
                item
                xs={12}
                sm={7}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      padding: "0px 5px",
                      borderRadius: "20px",
                      "& fieldset": {
                        border: "2px solid var(--grey-3)",
                      },
                      "&:hover fieldset": {
                        border: "2px solid var(--grey-3)",
                      },
                      "&.Mui-focused fieldset": {
                        border: "2px solid var(--grey-3)",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color: "white",
                    },
                  }}
                >
                  {isLoaded ? (
                    <Autocomplete
                      onPlaceChanged={() => {
                        const place = inputRef.current.getPlace(); // Get the selected place details
                        if (place.geometry && place.geometry.location) {
                          // Extract latitude and longitude
                          const lat = place.geometry.location.lat();
                          const lng = place.geometry.location.lng();
                          setGeolocation({
                            latitude: lat,
                            longitude: lng,
                            state: "granted",
                          });
                          // console.log("Selected Place:", lat, lng);

                          setLocationSearch(place.formatted_address);
                          setFilterTrigger((prev) => prev + 1); // Trigger filter update
                        }
                      }}
                      onLoad={(ref) => (inputRef.current = ref)}
                      options={{
                        fields: [
                          "geometry",
                          "address_components",
                          "formatted_address",
                        ],
                        componentRestrictions: { country: "CA" },
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Trouver un établissement"
                        onChange={(e) => {
                          setLocationSearch(e.target.value);
                        }}
                        style={{
                          width: "100%",
                          height: "42px",
                          padding: "10px 15px",
                          fontSize: "16px",
                          border: "2px solid var(--grey-3)",
                          borderRadius: "20px",
                          outline: "none",
                        }}
                      />
                    </Autocomplete>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  )}
                  <LocationOn
                    sx={{
                      position: "absolute",
                      right: "15px",
                      top: "8px",
                      color: locationSearch
                        ? "var(--primary)"
                        : "var(--grey-2)",
                    }}
                  />
                </FormControl>
                {!isSmMobile && (
                  <Grid
                    item
                    sx={{
                      color: "var(--gray-1)",
                      fontSize: "14px",
                      paddingX: 2,
                    }}
                  >
                    ou
                  </Grid>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Button
                  disabled={geolocation.state === "denied"}
                  disableRipple
                  fullWidth
                  variant="contained"
                  onClick={() => getGeoLocation()}
                  sx={{
                    justifyContent: "space-between",
                    backgroundColor: "transparent",
                    color: "var(--primary)",
                    borderRadius: "20px",
                    border: "2px solid var(--primary)",
                    boxShadow: "none",
                    transition: "all 0.25s",
                    transitionProperty: "background-color, color, transform",
                    ":hover": {
                      backgroundColor: "var(--primary)",
                      color: "var(--white)",
                      transform: "scale(1.05)",
                      boxShadow: "none",
                    },
                  }}
                  endIcon={<IoMdLocate />}
                >
                  Localiser
                </Button>
              </Grid>
            </Grid>
            <Grid
              xs={12}
              item
              lg={8}
              container
              alignItems="center"
              spacing={1}
              sx={{
                marginTop: isMobile ? 2 : 0,
              }}
            >
              {/* Left label */}
              <Grid
                item
                xs={12}
                md={2}
                lg={1.5}
                sx={{
                  color: "var(--gray-3)",
                  textTransform: "uppercase",
                  fontSize: "11px",
                  fontWeight: 500,
                  marginLeft: isMobile ? -2 : 0,
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-start" },
                  mb: { xs: 1, md: 0 },
                }}
              >
                Bannières
              </Grid>

              {/* Right logo grid */}
              <Grid
                item
                xs={12}
                md={10}
                lg={10.5}
                container
                spacing={1}
                justifyContent={{ xs: "center", md: "flex-start" }}
                sx={{
                  gap: 2,
                }}
              >
                {[
                  { id: "sprint", img: sprint, key: "sprintStationList" },
                  {
                    id: "petro_canada",
                    img: petroCanada,
                    key: "petroCanadaStationList",
                  },
                  {
                    id: "gulf",
                    img: gulf,
                    key: "GulfStationList",
                  },
                  { id: "eko", img: eko, key: "ekoStationList" },
                  {
                    id: "xtr",
                    img: xtr,
                    key: "XtrStationList",
                  },
                  { id: "sonerco", img: sonerco, key: "sonercoStationList" },
                  { id: "axco", img: axco, key: "axcoStationList" },
                  {
                    id: "vp_racing",
                    img: vp_racing,
                    key: "VpRacingStationList",
                  },
                  {
                    id: "irving",
                    img: irving,
                    key: "IrvingStationList",
                  },
                  {
                    id: "shell",
                    img: shell_logo,
                    key: "shellStationList",
                  },
                  {
                    id: "a&w",
                    img: a_w_logo,
                    key: "Restaurant",
                  },
                  {
                    id: "recharge_sprint",
                    img: recharge_logo,
                    key: "rechargeStationList",
                  }
                ].map((brand) => (
                  <Grid key={brand.id} item xs="auto">
                    <Box className="flex items-center justify-center">
                      <Checkbox
                        checked={selectedLocation.includes(brand.key)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedLocation((prev) => [...prev, brand.key]);
                          } else {
                            setSelectedLocation((prev) =>
                              prev.filter((item) => item !== brand.key),
                            );
                          }
                        }}
                        disableRipple
                        id={brand.id}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: { xs: 17, lg: 15 },
                            color: "var(--sprint-primary)",
                          },
                          padding: "2px",
                          marginRight: 1,
                        }}
                      />
                      <label htmlFor={brand.id}>
                        <Box
                          className={
                            isSmMobile
                              ? `w-[25px] h-[25px]`
                              : `w-[30px] h-[30px]`
                          }
                          sx={{
                            boxShadow: "1px 1px 1px 0 rgba(10, 10, 10, 0.3)",
                            borderRadius: "4px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={brand.img}
                            alt={brand.id}
                            className="w-full h-full object-cover"
                          />
                        </Box>
                      </label>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            sm={12}
            md={2}
            lg={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: isMobile ? 4 : 0,
            }}
          >
            <Box
              onClick={() => setAdvancedFilterOpen((prev) => !prev)}
              className="!flex !items-center !justify-end cursor-pointer"
            >
              <Typography
                className={` ${
                  advancedFilterOpen
                    ? "!text-[var(--primary)]"
                    : "!text-[var(--grey-2)]"
                }  !text-[11px] !uppercase !font-medium`}
                variant="body2"
                strong
                component={"span"}
              >
                Filters{" "}
                {activeFilterOption?.length > 0 &&
                  `(${activeFilterOption?.length})`}
              </Typography>
              <Typography
                className={`${
                  advancedFilterOpen
                    ? "!text-[var(--primary)]"
                    : "!text-[var(--grey-2)]"
                }  !text-[18px] !font-bold`}
                variant="body2"
                component={"span"}
              >
                {advancedFilterOpen ? (
                  <MdKeyboardArrowDown />
                ) : (
                  <MdKeyboardArrowRight />
                )}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        {advancedFilterOpen && (
          <AdvancedFilter
            {...{
              stationFilterData,
              handleActiveFilterOption,
              activeFilterOption,
              resetFilterHadnler,
              setActiveFilterOption,
              setSelectedLocation,
            }}
          />
        )}
      </Box>
      {/* Filter and Map */}
      <Grid container xs={12} rowSpacing={2}>
        <Grid
          xs={12}
          item
          md={6}
          lg={9}
          order={isMobile ? 1 : 2}
          sx={{
            height: isMobile ? 420 : "700px",
          }}
        >
          <GoogleMapComponent
            geolocation={geolocation}
            isLoaded={isLoaded}
            setNavigate={setNavigate}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          order={isMobile ? 2 : 1}
          sx={{ position: "relative" }}
        >
          {/* SideBar Menu */}
          <SideBarMenu
            {...{ setNavigate, navigate, geolocation, stationFilterData }}
          />
          <Box sx={{ height: "685px", overflowY: "auto" }}>
            {stations.length > 0 ? (
              stations?.map((item) => (
                <Station {...{ item, setNavigate, geolocation }} />
              ))
            ) : (
              <NoDataFound
                {...{
                  resetFilterHadnler,
                  setActiveFilterOption,
                  setSelectedLocation,
                }}
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});

export default FilterAndMap;
